module.exports = __webpack_public_path__ + "static/img/Queen of Cups.8b962c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Queen of Cups.jpg
// module id = 1291
// module chunks = 0